<template>
	<div v-if="context">
		<nk-wrapper spacing="lg">
			<nk-nav aria-label="Anfangsbuchstaben" variant="abc">
				<nk-nav-item
					v-for="(anfangsbuchstabe, anfangsbuchstabeIndex) in context.alphabet"
					:key="anfangsbuchstabeIndex"
					:link="`${
						context.taggingpfad.slice(-1) !== '/'
							? context.taggingpfad + '/'
							: context.taggingpfad
					}${anfangsbuchstabe}`"
				>
					{{ anfangsbuchstabe }}
				</nk-nav-item>
			</nk-nav>
		</nk-wrapper>
	</div>
</template>

<script>
import TemplatesDefault from '../../mixins/templates-default';

/**
 * @prop {array} context.alphabet
 * @prop {string} context.taggingpfad
 */
export default {
	name: 'NkTemplateServiceBwAbc',

	mixins: [TemplatesDefault],
};
</script>
